var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 20,
    r: 2,
    fill: "#B8BCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18Z",
    fill: "#B8BCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M19.2519 14.3805H6.50873L6.25935 12.8157H16.7332C17.0413 12.8167 17.3185 12.6132 17.4314 12.303L19.9252 5.50404C20.0767 5.08816 19.8879 4.61812 19.5035 4.45424C19.4154 4.41666 19.3216 4.39754 19.2269 4.39785H4.96259L4.36409 0.674585C4.30262 0.280896 3.98496 -0.00550544 3.61596 8.03043e-05H0.74813C0.334954 8.03043e-05 0 0.362469 0 0.809486C0 1.2565 0.334954 1.61889 0.74813 1.61889H2.99252L5.13716 14.6823C5.34279 15.9993 6.11398 16.0053 6.50873 15.9993H19.2519C19.665 15.9993 20 15.6369 20 15.1899C20 14.7429 19.665 14.3805 19.2519 14.3805Z",
    fill: "#B8BCBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b5132f89939c83e1c824727ba08a45d8.svg";
export { ForwardRef as ReactComponent };